var render = function render() {
  var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;return _c('div', { staticClass: "video-duration" }, [_vm._v(_vm._s(_vm.fmtSeconds(_vm.resource.duration / 1000)))]);
};
var staticRenderFns = [];

export { render, staticRenderFns };